import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import DataMining from './pages/DataMining';
import DigitalMarketing from './pages/DigitalMarketing';
import CyberSecurity from './pages/CyberSecurity';
import SecurityConsulting from './pages/SecurityConsulting';
import './App.css';

function App() {
  return (
    <Router>
      <Header />
      <div className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services/data-mining" element={<DataMining />} />
          <Route path="/services/digital-marketing" element={<DigitalMarketing />} />
          <Route path="/services/cyber-security" element={<CyberSecurity />} />
          <Route path="/services/security-consulting" element={<SecurityConsulting />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default App;
